import React, { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import ModifyReceiptTable from "../components/ModifyReceiptTable";
import loadercrs from "../assets/images/loadercrs.gif";

const ModifyReciept = () => {
  const { userDetails } = useSelector((state) => state.auth);
  const today = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [allCashReceiptData, setAllCashReceiptData] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAllCashReceiptData = async (fromDate, toDate) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/load_receipt_for_modification/${userDetails.dcode}/${userDetails.srocode}/${fromDate}/${toDate}`
      );
      setAllCashReceiptData(response.data);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data immediately for the current date when the page loads
  useEffect(() => {
    fetchAllCashReceiptData(today, today);
  }, []); // Runs only once on mount

  const handleOkButtonClick = () => {
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);

      if (from > to) {
        toast.error("To Date should not be earlier than From Date.");
        setFromDate(today); // Reset to current date if invalid
        setToDate(today);
        return;
      }

      fetchAllCashReceiptData(fromDate, toDate);
    } else {
      toast.error("Please select both From Date and To Date.");
    }
  };

  return (
    <>
      {/* Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <img src={loadercrs} alt="Loading..." className="w-48 h-48" />
        </div>
      )}

      <div
        className={`flex h-screen ${
          loading ? "pointer-events-none blur-sm" : ""
        }`}
      >
        <SideMenu />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
            {/* Left Side */}
            <div className="flex-1 p-4 overflow-y-auto">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                Modify Receipt
              </h1>
              <div className="max-w-full mx-auto p-1 rounded-md">
                {/* Date Inputs */}
                <div className="flex flex-col md:flex-row w-3/4 items-end gap-2">
                  <div className="flex-1">
                    <label className="text-sm font-medium text-gray-700">
                      Start Date
                    </label>
                    <input
                      type="date"
                      name="startdate"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      required
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2 mt-1"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="text-sm font-medium text-gray-700">
                      End Date
                    </label>
                    <input
                      type="date"
                      name="enddate"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      required
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2 mt-1"
                    />
                  </div>
                  <div className="flex">
                    <button
                      className="bg-blue-500 text-white text-sm px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none md:ml-2 mt-5 md:mt-1"
                      onClick={handleOkButtonClick}
                    >
                      OK
                    </button>
                  </div>
                </div>

                {/* Table Component */}
                {allCashReceiptData?.length > 0 && (
                  <div className="mt-1">
                    <ModifyReceiptTable data={allCashReceiptData} />
                  </div>
                )}
              </div>
            </div>

            {/* Right Side */}
            <div className="hidden md:block w-full md:w-64 h-full p-4">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModifyReciept;
